import {unwrap} from '@pocketbuy/outdoor-api-client';
import {client} from '../../api';
import {presentPhoneModels} from '../../phonePresentation';
import type {StockTransfer,TransferPlan} from './types';
const root='/v1/stock-transfers';
export const stockTransferApi={
 list:async(params:{q:string;status:string;direction:string;point?:number;before:number})=>presentPhoneModels(await unwrap<{items:StockTransfer[];nextCursor:number|null}>(client.get(root,{params}))),
 get:async(id:number)=>presentPhoneModels(await unwrap<StockTransfer>(client.get(`${root}/${id}`))),
 save:async(id:number|undefined,plan:TransferPlan)=>presentPhoneModels(await unwrap<StockTransfer>(id?client.put(`${root}/${id}`,plan):client.post(root,plan))),
 act:async(id:number,action:string,data:{version:number;note?:string;imei?:string;deviceId?:number;confirmed?:boolean})=>presentPhoneModels(await unwrap<StockTransfer>(client.post(`${root}/${id}/${action}`,data))),
};
